var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26875 0 0 6.26875 0 14C0 21.7312 6.26875 28 14 28C21.7312 28 28 21.7312 28 14C28 6.26875 21.7312 0 14 0ZM18.8344 14.2031L11.1469 19.7656C10.9813 19.8844 10.75 19.7656 10.75 19.5625V18.0969C10.75 17.7781 10.9031 17.475 11.1625 17.2875L15.7062 14L11.1625 10.7125C10.9031 10.525 10.75 10.225 10.75 9.90312V8.4375C10.75 8.23438 10.9813 8.11563 11.1469 8.23438L18.8344 13.7969C18.9719 13.8969 18.9719 14.1031 18.8344 14.2031Z",
    fill: "#006854"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircle);
export default __webpack_public_path__ + "static/media/right-circle.0dc4ec0d6954d78bacd2bdde665390bf.svg";
export { ForwardRef as ReactComponent };